/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {XhrHttpModule} from "@intuitionrobotics/thunderstorm/frontend";
import {HttpMethod} from "@intuitionrobotics/thunderstorm";
import {Module} from "@intuitionrobotics/ts-common";
import {ApiBinder_DBQuery} from "@intuitionrobotics/db-api-generator";
import {AnyDb_Contact} from "@app/ir-q-app-common/shared/types";

class ContactsModule_Class
    extends Module {

    constructor() {
        super("ContactsModule");
    }

    async queryContacts() {
        return XhrHttpModule
            .createRequest<ApiBinder_DBQuery<AnyDb_Contact>>(HttpMethod.POST, "query")
            .setJsonBody({})
            .setRelativeUrl("/v2/contacts/queryContactsByIds")
            .setOnError("error retrieving contact groups from kaspero")
            .executeSync()
    }

}

export const ContactsModule = new ContactsModule_Class();
